import React, { createContext, useState, useEffect, ReactNode } from 'react';
import { UserRole } from '../types/UserRole';

interface UserRoleContextProps {
  userRole: UserRole | null;
  setUserRole: (role: UserRole | null) => void;
}

export const UserRoleContext = createContext<UserRoleContextProps>({} as UserRoleContextProps);

export const UserRoleProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [userRole, setUserRole] = useState<UserRole | null>(null);

  useEffect(() => {
    const stored = localStorage.getItem('userRole');
    if (stored) {
      try {
        setUserRole(JSON.parse(stored));
      } catch {
        localStorage.removeItem('userRole');
      }
    }
  }, []);

  useEffect(() => {
    if (userRole) {
      localStorage.setItem('userRole', JSON.stringify(userRole));
    } else {
      localStorage.removeItem('userRole');
    }
  }, [userRole]);

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === 'userRole') {
        if (event.newValue) {
          try {
            setUserRole(JSON.parse(event.newValue));
          } catch {
            setUserRole(null);
            localStorage.removeItem('userRole');
          }
        } else {
          setUserRole(null);
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return (
    <UserRoleContext.Provider value={{ userRole, setUserRole }}>
      {children}
    </UserRoleContext.Provider>
  );
};
